module.exports = __webpack_public_path__ + "static/media/orange.b773d9ab.png";